// extracted by mini-css-extract-plugin
module.exports = {"table":"ImportStockShow_table__17Q0U","error":"ImportStockShow_error__2ThkS"};